import routes from "./api";
export default Object.assign(routes, { 
  api_base_url: process.env.VUE_APP_BACKEND_API_URL,
  host_url: process.env.VUE_APP_HOST_URL,
  strapi_api_url: "http://127.0.0.1:1337/api",
});
